import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PrlLoginPageComponent} from './components/prl-login-page/prl-login-page.component';
import {
    MxButtonModule, MxDynamicFieldsModule, MxFormModule, MxInfoTooltipModule, MxMaterialModule, MxPreloaderModule,
    MxSharedModule
} from 'mx-core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PrlAuthenticationRoutingModule} from './prl-authentication-routing.module';
import {PrlContactUsPageComponent} from './components/prl-contact-us-page/prl-contact-us-page.component';
import {HttpClientModule} from '@angular/common/http';
import {PrlContactUsService} from './services/contact-us/prl-contact-us.service';
import {
    PrlTermsAndConditionsPageComponent
} from './components/prl-terms-and-conditions-page/prl-terms-and-conditions-page.component';
import {PrlLanguageModule} from '../prl-language/prl-language.module';
import {PrlLanguageService} from '../prl-language/services/prl-language.service';
import {RecaptchaFormsModule, RecaptchaModule} from 'ng-recaptcha';
import {TranslateModule} from '@ngx-translate/core';
import {PrlRegistrationPageComponent} from './components/prl-registration-page/prl-registration-page.component';
import {BoFilterModule} from '../../../../../bo/src/app/bo-ui-framework/bo-filter/bo-filter.module';
import {
    MxAuthenticationModule
} from '../../../../../mx-core/src/lib/modules/mx-authentication/mx-authentication.module';
import {PrlChangePasswordComponent} from './components/prl-change-password/prl-change-password.component';
import {
    PrlExternalResetPasswordComponent
} from './components/prl-external-reset-password/prl-external-reset-password.component';
import {PrlUnsubscribeComponent} from './components/prl-unsubscribe/prl-unsubscribe.component';
import {
    PrlPortalNotificationPageComponent
} from './components/prl-portal-notification-page/prl-portal-notification-page.component';

@NgModule({
    declarations: [
        PrlChangePasswordComponent,
        PrlContactUsPageComponent,
        PrlExternalResetPasswordComponent,
        PrlLoginPageComponent,
        PrlPortalNotificationPageComponent,
        PrlRegistrationPageComponent,
        PrlTermsAndConditionsPageComponent,
        PrlUnsubscribeComponent
    ],
    imports: [
        HttpClientModule,
        CommonModule,
        MxMaterialModule,
        PrlAuthenticationRoutingModule,
        ReactiveFormsModule,
        MxButtonModule,
        MxDynamicFieldsModule,
        MxFormModule,
        MxSharedModule,
        PrlLanguageModule,
        RecaptchaModule,
        RecaptchaFormsModule,
        TranslateModule,
        BoFilterModule,
        MxAuthenticationModule,
        FormsModule,
        MxInfoTooltipModule,
        MxPreloaderModule
    ],
    providers: [
        PrlContactUsService,
        PrlLanguageService
    ]
})
export class PrlAuthenticationModule {
}
